// Call-time translation for the few label modules the app shell loads
// statically (meeting types, proctoring events, the ATS integrations
// provider). Importing utils/domainText there would pull the whole English
// `domain` bundle into the shell, so these keep their English text in code
// and pass it as the default: English users see it as is, other languages
// read the loaded `domain` bundle. Tests pin each English default to en/recruiter/domain.json.
import i18n from 'i18n';
import type { DomainSingularKey } from 'utils/domainText';

export const domainTextOr = (
  key: DomainSingularKey,
  englishDefault: string
): string => i18n.t(key, { ns: 'domain', defaultValue: englishDefault });

/** English defaults for shell strings that have no label table of their own. */
export const SHELL_DOMAIN_DEFAULTS = {
  'atsIntegrations.fetchFailed': 'Failed to fetch ATS integrations',
} as const satisfies Partial<Record<DomainSingularKey, string>>;

export const shellDomainText = (
  key: keyof typeof SHELL_DOMAIN_DEFAULTS
): string => domainTextOr(key, SHELL_DOMAIN_DEFAULTS[key]);
